import { useAuthPersistedStore } from "shared";
import api, { BaseApiService } from "shared/api";
import { withToast } from "shared/utils";
import { v4 as uuid } from "uuid";

class AuthService extends BaseApiService {
  async login() {
    await api.get(this.ENDPOINTS.auth.csrf_cookie);
    const loginResponse = await api.post(this.ENDPOINTS.auth.realm_login, {
      state:
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
          ? "local" + uuid()
          : uuid(),
    });

    if (loginResponse.status === 200) {
      window.location.replace(loginResponse.data.data.login_url);
    }
  }
  async loginConfirm(payload) {
    return await withToast(() =>
      api.post(this.ENDPOINTS.auth.realm_login_confirm, payload)
    );
  }

  async logout() {
    const logoutResponse = await api.post(this.ENDPOINTS.auth.realm_logout);
    if (logoutResponse?.status === 200) {
      const confirmLogout = await api.post(
        this.ENDPOINTS.auth.realm_logout_confirm
      );
      if (confirmLogout?.status === 200) {
        useAuthPersistedStore.getState().setIsLoggedIn(false);
        window.location.replace(logoutResponse.data.logout_url);
      }
    }
  }
}

export const authService = new AuthService();
